import { createContentCollection } from './content'

// Manual ordering of thoughts
const thoughtsOrder = [
  'designing-for-tvs',
  'extending-tailwind',
  'respecting-reduce-motion',
  'please-optimize-your-photos',
  'making-figma-plugins',
  'the-books-that-made-me',
  'colophon',
]

const modules = import.meta.glob('/src/content/thoughts/*.mdx', { eager: true, import: 'frontmatter' })
const { items: thoughts, getBySlug: getThoughtBySlug } = createContentCollection(
  modules,
  '/src/content/thoughts/',
  thoughtsOrder
)

export { thoughts, getThoughtBySlug }
